import {
  Navbar,
  Nav,
  NavItems,
  NavItem,
  NavLink,
  ButtonLink,
  DropdownMenu,
  DropdownItem,
  SubNavLink,
  Caret,
} from "./styles";
import Icon from "../../../../Icon";
import constants from "../../../../../constants";
import { connect } from "react-redux";
import { UserDto } from "../../../../../types/user.dto";
import { useState } from "react";
import CaretDown from "../../../../../assets/icons/caret-down.svg";

interface ComponentProps {
  user: UserDto;
}

const Component = ({ user }: ComponentProps) => {
  const [activeDropdown, setActiveDropdown] = useState<string>();
  const [activeDropdownChildren, setActiveDropdownChildren] =
    useState<string>();

  return (
    <Navbar>
      <Nav>
        <NavItems>
          <>
            {constants.menu.desktopMenu.map((menuItem, menuIndex) => {
              const hasChildren =
                !!menuItem.children && menuItem.children?.length > 0;
              const isActiveDropdown =
                menuItem.link === activeDropdown ||
                menuItem.link === activeDropdownChildren;
              return (
                <NavItem key={`menu-${menuIndex}`}>
                  {hasChildren ? (
                    <ButtonLink
                      onClick={(event) => {
                        setActiveDropdown(
                          isActiveDropdown ? "" : menuItem.link
                        );
                      }}
                      className={isActiveDropdown ? "active" : ""}
                    >
                      <span>
                        {!!menuItem.icon && (
                          <Icon
                            icon={menuItem.icon}
                            color="#FFFFFF"
                            size="18px"
                          />
                        )}

                        {menuItem.title}
                      </span>

                      {hasChildren && (
                        <Caret className="caret">
                          <Icon icon={CaretDown} color="#FFFFFF" size="18px" />
                        </Caret>
                      )}
                    </ButtonLink>
                  ) : (
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "active" : undefined
                      }
                      to={`/dashboard${menuItem.link}`}
                      onClick={() => {
                        setActiveDropdown("");
                        setActiveDropdownChildren(menuItem.link);
                      }}
                    >
                      <span>
                        {!!menuItem.icon && (
                          <Icon
                            icon={menuItem.icon}
                            color="#FFFFFF"
                            size="18px"
                          />
                        )}

                        {menuItem.title}
                      </span>

                      {hasChildren && (
                        <Caret className="caret">
                          <Icon icon={CaretDown} color="#FFFFFF" size="18px" />
                        </Caret>
                      )}
                    </NavLink>
                  )}

                  {hasChildren && (
                    <DropdownMenu
                      amountItems={menuItem.children?.length}
                      isActiveDropdown={isActiveDropdown}
                    >
                      {menuItem.children?.map((submenuItem, submenuIndex) => (
                        <DropdownItem key={`submenu-item-${submenuIndex}`}>
                          <SubNavLink
                            className={({ isActive }) =>
                              isActive ? "active" : undefined
                            }
                            onClick={() =>
                              setActiveDropdownChildren(menuItem.link)
                            }
                            to={`/dashboard${menuItem.link}${submenuItem.link}`}
                          >
                            {submenuItem.title}
                          </SubNavLink>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  )}
                </NavItem>
              );
            })}
          </>
        </NavItems>
      </Nav>
    </Navbar>
  );
};

const states = ({ userStore }) => {
  const { data: user } = userStore;
  return {
    user,
  };
};

export default connect(states)(Component);
